import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { PopoverAnchor } from '../../../../popover/patched-popover/PatchedPopover.mjs';

const SingleSelectAnchor = forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ jsx(
    PopoverAnchor,
    {
      "data-scope": "single-select",
      "data-part": "anchor",
      ref: forwardedRef,
      ...props
    }
  );
});

export { SingleSelectAnchor as SelectAnchor };
//# sourceMappingURL=Anchor.mjs.map
